import { useTranslation } from 'react-i18next';

export const keyPrefix = 'top_match_card_info';
export const useTopMatchCardInfoTranslation = () => useTranslation('entities', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    tag: 'Карточка',
    fio: 'ФИО',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    tag: 'Card',
    fio: 'Full name',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    tag: 'Cartão',
    fio: 'Nome completo',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    tag: 'Tarjeta',
    fio: 'Nombre completo',
  },
}) : {}) as Record<string, unknown>;
